import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import { Card, BreadCrumb, Modal, Confirm } from '../../components';
import { Translate } from '../../contexts/Language';
import { DataTableColumns } from '../../config/DataTableColumns';
import { Config } from '../../config';
import { Service } from '../../services';

import { ErrorMessage, Validator } from '../../components/Validator';

export class Rules extends Component {
  constructor(props) {
    super(props);

    this.Refs = React.createRef();

    this.state = {
      dataTable: {
        columns: DataTableColumns.transferOptionsRules,
        rows: [],
      },
      modal: false,
      modalTitle: '',
      formData: {
        psp: '',
        transferType: '',
        description: '',
      },
      validation: {
        error: false,
        message: '',
      },
    };

    this.pspOptions = [];
    this.typeOptions = [
      { value: 'W', label: <span>Withdrawal</span> },
      { value: 'D', label: <span>Deposit</span> },
    ];
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    this.onDatatable();

    Service.TransferOptions.TransferOptionList().then(response => {
      if (response) {
        let i = 0;
        for (i = 0; i < response.length; i += 1) {
          this.pspOptions.push({
            value: response[i].id,
            label: (
              <span>
                <img src={`/assets/psp-logo/${(response[i].logo || 'defaultlogo.svg')}`} className="mr-2" alt="" width="25" />
                {response[i].title}
              </span>
            ),
          });
        }
      }
    });
  }

  onDatatable() {
    Config.utilities.loadingFetch();
    Service.TransferOptions.Rules().then(response => {
      if (response) {
        const { dataTable } = this.state;

        dataTable.rows = response;

        this.setState({
          dataTable,
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  onFormChange(value, key) {
    const { formData } = this.state;

    formData[key] = value;

    this.setState({
      formData,
    });
  }

  onNew() {
    this.setState({
      modal: true,
      modalTitle: Translate('Add New Payment Service Rule'),
      formData: {
        ruleId: 0,
        transferType: '',
        psp: '',
        description: '',
      },
      validation: {
        error: false,
        message: '',
      },
    });
  }

  onSave() {
    const { formData } = this.state;

    if (this.isValid(formData)) {
      Config.utilities.loadingFetch();

      formData.transferType = formData.transferType.value;
      formData.psp = formData.psp.value;
      Service.TransferOptions.RuleSave(formData).then(response => {
        if (response.error) {
          this.setState({
            validation: {
              error: response.error,
              message: response.message,
            },
          });
        } else {
          this.setState({
            modal: false,
            formData: {
              transferType: '',
              psp: '',
              description: '',
              ruleId: 0,
            },
          });

          this.onDatatable();
        }
        Config.utilities.loadingFetch();
      });
    }
  }

  onEdit(id) {
    Config.utilities.loadingFetch();

    Service.TransferOptions.GetRule({ id }).then(response => {
      if (response) {
        const { formData } = this.state;
        formData.description = response.description;
        formData.ruleId = response.ruleId;
        [formData.psp] = this.pspOptions.filter(item => item.value === response.id);
        [formData.transferType] = this.typeOptions.filter(item => item.value === response.transferType);

        this.setState({
          formData,
          modal: true,
          modalTitle: Translate('Edit Payment Service Rule'),
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  onDelete(id) {
    Confirm({
      title: Translate('Are you sure?'),
      type: { warning: true },
      description: Translate('This Transfer Option Rule will be deleted'),
      onConfirm: () => {
        Config.utilities.loadingFetch();
        Service.TransferOptions.DeleteRule({ id }).then(response => {
          if (response) {
            this.setState({
              validation: response,
            });
          }

          this.onDatatable();
          Config.utilities.loadingFetch();
        });
      },
      onCancel: () => { },
    });
  }

  isValid(data) {
    const error = Validator.Valid(data, this.Refs);

    this.setState({
      validation: error,
    });

    return !error.error;
  }

  render() {
    const { modalTitle, modal, validation, formData, dataTable } = this.state;
    return (
      <>
        <BreadCrumb Title={Translate('PSP Rules')} Name={Translate('PSP Rules')} />

        <Modal Title={modalTitle} Show={modal} onClose={() => this.setState({ modal: false })}>
          <form className="form-horizontal" name="saveForm" ref={this.Refs}>
            <ErrorMessage Validation={validation} />
            <div className="row">
              <p className="text-muted mb-2 ml-1 col-md-12 font-12">{Translate('Rule Information')}</p>
              <div className="col-md-12">
                <div className="form-group row ml-1 mr-1">
                  <label htmlFor="transfer-type" className="col-sm-4 col-form-label">{Translate('Transfer Option')}</label>
                  <div className="col-sm-8">
                    <Select
                      id="transfer-type"
                      value={formData.psp}
                      onChange={e => this.onFormChange(e, 'psp')}
                      options={this.pspOptions}
                    />
                  </div>
                </div>

              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group row ml-1 mr-1">
                  <label htmlFor="transfer-type" className="col-sm-4 col-form-label">{Translate('Transfer Type Option')}</label>
                  <div className="col-sm-8">
                    <Select
                      id="transfer-type"
                      value={formData.transferType}
                      onChange={e => this.onFormChange(e, 'transferType')}
                      options={this.typeOptions}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group row ml-1 mr-1">
                  <label htmlFor="transfer-type" className="col-sm-4 col-form-label">{Translate('Description')}</label>
                  <div className="col-sm-8">
                    <input type="text" className="form-control" id="description" name="description" value={formData.description} onChange={e => this.onFormChange(e.target.value, 'description')} />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group row ml-1 mr-1">
                  <label htmlFor="save-form" className="col-sm-4 col-form-label" />
                  <div className="col-sm-8">
                    <button type="button" className="btn btn-info float-right" onClick={() => this.onSave()}>
                      <i className="far fa-save mr-2" />
                      {Translate('Save Form')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
        <Card Title="Payment Service Rules" Description="Customer panel payment systems rules.">
          <div className="row">
            <div className="col-md-12">
              <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={() => this.onNew()}>
                <i className="fas fa-plus mr-2" />
                {Translate('Add New Rule')}
              </button>
              {dataTable.rows.length === 0 ?
                (
                  <div className="alert alert-light" role="alert">
                    <em>
                      <strong className="mr-2">No record!</strong>
                      {Translate('No records found for the filter.')}
                    </em>
                  </div>
                ) :
                (
                  <DataTable
                    noHeader
                    columns={dataTable.columns(this.onEdit, this.onDelete)}
                    data={dataTable.rows}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    pagination
                    highlightOnHover
                  />
                )}
            </div>
          </div>
        </Card>
      </>
    );
  }
}
